import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { toast } from "react-toastify";
import {  getUsers } from '../../services/userServicer';
import Select from 'react-select';
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from 'react-router-dom';
import {updateSurveyApi ,fetchOneSurveyApi, createSurvey, fetchAllDataApi } from "src/services/question";
import i18n from "src/i18n";


interface SurveyFormValues {
  en_name: string;
  ar_name: string;
  en_description: string;
  ar_description: string;
  questions: string[];
  users: string[];
}

interface SelectOption {
  value: string;
  label: string;
}

const UpdateSurvey = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;

  const [loading, setLoading] = useState(true);
  const [usersOptions, setUsersOptions] = useState<SelectOption[]>([]);
  const [questionsOptions, setQuestionsOptions] = useState<SelectOption[]>([]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm<SurveyFormValues>();

  useEffect(() => {
    const fetchSurveyDetails = async () => {
      if (!id) return;
      try {
        const response = await fetchOneSurveyApi(`publicSurvey/${id}`);
        if (response?.success) {
          setValue("en_name", response.data.name_en || "");
          setValue("ar_name", response.data.name_ar || "");
          setValue("en_description", response.data.description_en || "");
          setValue("ar_description", response.data.description_ar || "");
          setValue(
            "questions",
            response.data?.bankQuestionSurveys?.map((q: any) => q.bankQuestionId) || []
          );
          setValue(
            "users",
            response.data.publicSurveyUsers?.map((u: any) => u.userId) || []
          );
        }
      } catch (error) {
        toast.error("Error fetching survey details");
      }
    };
    const fetchUsers = async () => {
        try {
          const response: any = await getUsers("", 10000, 0);
           
          if (response && response.success) {
            const indexedData = response.data.map((user: any, idx: number) => ({
              value: user.id,
              label: user.name
            }));
            setUsersOptions(indexedData); 
          } else if (response && response.data.length === 0) {
            setUsersOptions([]);
            
          } else {
            toast.error("Failed to fetch users data");
          }
        } catch (error: any) {
          toast.error("Error fetching users data:", error);
        }
      };
    
      const fetchQuestions = async () => {
        try {
          const questions: any = await fetchAllDataApi();
          
            if (questions.success) {
            let questionsOptions = questions.data.map((question: any) => ({
              value: question.id,
              label: i18n.language === 'ar' ? question.question_ar : question.question_en
            }));
            setQuestionsOptions(questionsOptions);
          } else {
            toast.error(questions.message);
          }
        } catch (error: any) {
          toast.error(error.message);
        }
      };
    

    const fetchData = async () => {
      await fetchUsers();
      await fetchQuestions();
      if (isEditing) {
        await fetchSurveyDetails();
      }
      setLoading(false);
    };

    fetchData();
  }, [id, setValue, i18n.language]);

  const onSubmit = async (formData: SurveyFormValues) => {
    try {
      // Transform data to match API schema
      const payload = {
        name_en: formData.en_name,
        name_ar: formData.ar_name,
        description_en: formData.en_description,
        description_ar: formData.ar_description,
        questions: formData.questions,
        users: formData.users
      };
  
      const response: any = await updateSurveyApi(id, payload);
      
      if (response && response.success) {
        toast.success(response.message);
        navigate("/viewsurvey");
      } else {
        toast.error(response?.message || "Update failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };
  return (
    <div className="root">


         <Breadcrumb>
           <BreadcrumbItem>{t("surveys.Surveys")}</BreadcrumbItem>
   <span>/</span>
      <BreadcrumbItem active  className="text-orange"
      >{t("surveys.Update Survey")}</BreadcrumbItem>
    </Breadcrumb>
      <h5 className="mb-lg">
        {isEditing ? t("surveys.Update Survey") : t("surveys.Create Survey")}
      </h5>

      {!loading && (
        <div className="container_info rounded bg-white p-4">
          <form onSubmit={handleSubmit(onSubmit)} className="create-compliance-form">
            <div className="form-section2 mb-2">
              <h5 className="section-title">{t("surveys.BasicInfo")}</h5>
            <div className="form-row">
                <div className="form-group flex-item">
                <label>{t("surveys.NameEn")}</label>
                <input type="text" className="form-control" {...register("en_name", { required: true })} />
              </div>
              <div className="form-group flex-item">
                <label>{t("surveys.NameAr")}</label>
                <input type="text" className="form-control" {...register("ar_name", { required: true })} />
              </div>
            </div>
             <div className="form-row">
               <div className="form-group flex-item">
                <label>{t("surveys.DescriptionEn")}</label>
                <input type="text" className="form-control" {...register("en_description", { required: true })} />
              </div>
              <div className="form-group flex-item">
                <label>{t("surveys.DescriptionAr")}</label>
                <input type="text" className="form-control" {...register("ar_description", { required: true })} />
              </div>
             </div>
              </div>


            <div className="form-row">
                <div className="form-section2 flex-item">
              <h5 className="section-title">{t("surveys.questions")}</h5>
              <div className="form-group">
                <label>{t("surveys.questions")}</label>
                <Select<SelectOption, true>
                  options={questionsOptions}
                  isMulti
                  className="basic-single"
                  classNamePrefix="select"
                  value={questionsOptions.filter((option) => watch("questions")?.includes(option.value))}
                  onChange={(selectedOptions) => {
                    setValue("questions", selectedOptions.map((option) => option.value));
                    trigger("questions");
                  }}
                />
              </div>
            </div>



              <div className="form-section2 flex-item">
             <h5 className="section-title">{t("surveys.users")}</h5>
              <div className="form-group">
                 <label className="form-label">{t("surveys.users")}</label>
                 <Select<SelectOption, true>
                  options={usersOptions}
                  isMulti
                  className="basic-single"
                  classNamePrefix="select"
                  value={usersOptions.filter((option) =>
                    watch("users")?.includes(option.value)
                  )}
                  onChange={(selectedOptions) => {
                    const values = selectedOptions.map((option) => option.value);
                    setValue("users", values);
                    trigger("users");
                  }}
                />
              </div>
            </div>
            </div>

             <div className="d-flex">

            <button type="submit" className="btn-create ms-auto">
              {isEditing ? t("surveys.Update Survey") : t("surveys.Create Survey")}
            </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default UpdateSurvey;
